module.exports = __webpack_public_path__ + "52138d0096996c2033a5e1cc882eb321.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-orange.png
// module id = 2841
// module chunks = 0